import { render, staticRenderFns } from "./Complaintlearner.vue?vue&type=template&id=6c1b9306&"
import script from "./Complaintlearner.vue?vue&type=script&lang=js&"
export * from "./Complaintlearner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports